module.exports = __webpack_public_path__ + "static/ch-site-27daf3480062da31d2720ff37e151350.png";